import { FunctionComponent, PropsWithChildren, useMemo } from "react";
import { GlobalWithAmplitude } from "./types";
import { LoggerAnalytics } from "./LoggerAnalytics";
import { AmplitudeAnalytics } from "./AmplitudeAnalytics.tsx";
import AnalyticsContext from "./AnalyticsContext.tsx";
import { useCookies } from "react-cookie";

const ANALYTICS_UID_COOKIE_NAME = "analytics_uid";

const AnalyticsProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const global = globalThis as GlobalWithAmplitude;
  const [cookies] = useCookies([ANALYTICS_UID_COOKIE_NAME]);

  // Memoize analytics instance to prevent unnecessary re-renders of consumers
  const analytics = useMemo(() => {
    return global.amplitude
      ? new AmplitudeAnalytics(cookies[ANALYTICS_UID_COOKIE_NAME] ?? null, global.amplitude, global.experiments)
      : new LoggerAnalytics();
  }, [global.amplitude, global.experiments, cookies]);

  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};

export default AnalyticsProvider;
